/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartPie80S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C8.4 2 5.1 3.9 3.3 7 2.5 8.5 2 10.2 2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2zm-1 2.1v6.2L5.6 7.2C6.9 5.5 8.9 4.3 11 4.1z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChartPie80S as ChartPie80S };
